import clsx from 'clsx';
import { Error } from 'components/Form/Error/Error';
import React from 'react';
import { useSelector } from 'react-redux';
import { getAlertsByScreen } from 'reducers/alerts/AlertsSelectors';
import { RootState } from 'store';
import { AlertScreen } from 'types/Alert';

import classes from './ErrorList.module.scss';

interface ErrorListProps {
    screen?: AlertScreen;
    className?: string;
}

const ErrorList: React.FC<ErrorListProps> = props => {
    const alerts = useSelector((state: RootState) => getAlertsByScreen(state, props.screen));

    return (
        <>
            {alerts.length > 0 && (
                <div className={clsx('w-full ', props.className)}>
                    <div className={classes.root}>
                        {alerts.map(alert => (
                            <Error key={alert.uuid} title={alert.text} variant={alert.variant} />
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default ErrorList;
